export const RULE_MANAGER_SHOW = 'RULE_MANAGER_SHOW'

export const GET_TEMPLATE_TO_EDIT = 'GET_TEMPLATE_TO_EDIT'

export const UPDATE_CAMPAIGN_SELECTION = 'UPDATE_CAMPAIGN_SELECTION'

export const TURN_RULES_SUCCESS = 'TURN_RULES_SUCCESS'

export const DELETE_FROM_TEMPLATE_SUCCESS = 'DELETE_FROM_TEMPLATE_SUCCESS'
